import React from "react";
import usePrimaryColor from "../../hooks/usePrimaryColor";
import { useTranslation } from "react-i18next";
import { Avatar, Box, Typography } from "@mui/material";

export default function TitleWithIcon({ children, title }) {
  const color = usePrimaryColor();
  const { t } = useTranslation();
  return (
    <Box display="flex" alignItems="center">
      <Avatar
        sx={{
          bgcolor: color,
          color: "white",
          mr: 2,
          width: 40,
          height: 40,
        }}
      >
        {children}
      </Avatar>
      <Box>
        <Typography variant="h6">{t(title)}</Typography>
      </Box>
    </Box>
  );
}
